//Logout route
import { logout } from '@/api/calls/auth/auth.api';
import { useGlobalStore } from '@/stores/global';

export const LOGOUT_ROUTE = {
  path: '/logout',
  name: 'logout',
  component: () => import('@/views/logout/LogoutView.vue'),
  beforeEnter: () => {
    useGlobalStore().isAppLoading = true;

    // perform a logout and redirect to the login page
    logout().then(() => {
      window.location.assign(useGlobalStore().login_url);
    });

    return false;
  }
};
